import { CardContent, Grid } from '@mui/material';
import { formatCurrency } from 'common/constants/currency';
import { useStoreSelector } from 'v3/data/store';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';
import { SubtitleLarge } from 'v3/shared/typography/SubtitleLarge';
import {
  BodySmallRegularStyled,
  CardHeaderStyled,
  CardStyled,
  Content,
  GridFinancingItem,
  LeftAlignedGrid,
} from '../styles';

const MAX_ACCESSORIES = 3;

export const OnlineFinancingInformation = () => {
  const { paymentDetails } = useStoreSelector((store) => store.onlineContracting);

  const items = paymentDetails?.items ?? [];

  const mainItem = items.length ? items.reduce((prev, curr) => (curr.price > prev.price ? curr : prev)) : null;

  const accessories = mainItem ? items.filter((item) => item !== mainItem) : [];
  const filledAccessories = Array.from({ length: MAX_ACCESSORIES }).map((_, index) => accessories[index] || null);

  return (
    <CardStyled>
      <CardHeaderStyled
        title={
          <Content>
            <SubtitleLarge>Financiamento</SubtitleLarge>
          </Content>
        }
      />
      <CardContent>
        <LeftAlignedGrid>
          <Grid container spacing={2}>
            <GridFinancingItem size={{ xs: 6, sm: 6, md: 4 }}>
              <BodySmallRegularStyled>Item</BodySmallRegularStyled>
              <BodySmallRegular className="empty-line">{mainItem?.name || ''}</BodySmallRegular>
            </GridFinancingItem>
            <GridFinancingItem size={{ xs: 6, sm: 6, md: 4 }}>
              <BodySmallRegularStyled>Total do produto</BodySmallRegularStyled>
              <BodySmallRegular className="empty-line">
                {mainItem?.name && mainItem?.price ? formatCurrency(mainItem?.price) : ''}
              </BodySmallRegular>
            </GridFinancingItem>
            <GridFinancingItem size={{ xs: 6, sm: 6, md: 4 }}>
              <BodySmallRegularStyled>IMEI</BodySmallRegularStyled>
              <BodySmallRegular className="empty-line">
                {paymentDetails.device.imei ? paymentDetails.device.imei : ''}
              </BodySmallRegular>
            </GridFinancingItem>

            {filledAccessories.map((accessory, index) => (
              <GridFinancingItem size={{ xs: 6, sm: 6, md: 4 }} key={`name-${index}`}>
                <BodySmallRegularStyled>Acessório {index + 1}</BodySmallRegularStyled>
                <BodySmallRegular className="empty-line">{accessory?.name ?? '-'}</BodySmallRegular>
              </GridFinancingItem>
            ))}

            {filledAccessories.map((accessory, index) => (
              <GridFinancingItem size={{ xs: 6, sm: 6, md: 4 }} key={`price-${index}`}>
                <BodySmallRegularStyled>Valor do Acessório {index + 1}</BodySmallRegularStyled>
                <BodySmallRegular className="empty-line">
                  {accessory?.name && accessory?.price ? formatCurrency(accessory.price) : '-'}
                </BodySmallRegular>
              </GridFinancingItem>
            ))}
            <GridFinancingItem size={{ xs: 6, sm: 6, md: 4 }}>
              <BodySmallRegularStyled>Origem</BodySmallRegularStyled>
              <BodySmallRegular className="empty-line">
                {paymentDetails.orderId ? 'São Paulo - SP' : ''}
              </BodySmallRegular>
            </GridFinancingItem>
            <GridFinancingItem size={{ xs: 6, sm: 6, md: 3 }}>
              <BodySmallRegularStyled>Destino</BodySmallRegularStyled>
              <BodySmallRegular className="empty-line">
                {paymentDetails.orderId ? paymentDetails.address.cityState : ''}
              </BodySmallRegular>
            </GridFinancingItem>
          </Grid>
        </LeftAlignedGrid>
      </CardContent>
    </CardStyled>
  );
};
